var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeboards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.533,
    height: 27.609,
    viewBox: "0 0 25.533 27.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noticeboards",
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Noticeboard-Copy",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noticeboard-icon-dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M5.333,25.928,2.181,7.908,7.955,6.9v3.839a1.011,1.011,0,0,0,1.01,1.011h4.511a1.011,1.011,0,0,0,1.011-1.011V5.755l5.714-1,3.152,18.02Zm4.644-16.2h2.489v-7.2H9.976Zm15.541,13.7-3.5-20.011a1.008,1.008,0,0,0-1.169-.821L14.487,3.7V1.51A1.011,1.011,0,0,0,13.475.5H8.965a1.011,1.011,0,0,0-1.01,1.01V4.847L.837,6.092A1.012,1.012,0,0,0,.015,7.261l3.5,20.011a1.011,1.011,0,0,0,.993.837,1.07,1.07,0,0,0,.176-.015l20.011-3.5A1.009,1.009,0,0,0,25.518,23.423Z",
    transform: "translate(0 -0.5)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeboards);
export default __webpack_public_path__ + "static/media/noticeboards.6b49d5d93ed48a73d9f67417aa2b869a.svg";
export { ForwardRef as ReactComponent };